import { Box, Button, SvgIcon } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { EditDrawerContext } from 'components/@home/@documents/SentDocuments/EditDrawer';
import { SendDrawerContext } from 'components/@home/@documents/SentDocuments/SendDrawerContext';
import SendIcon from 'mdi-react/SendIcon';
import React, { useContext } from 'react';
import { I18n } from 'utils/i18n';

const SentDocumentsToolbar = () => {
  const editDrawer = useContext(EditDrawerContext);
  const sendDrawer = useContext(SendDrawerContext);
  const handleCreateClick = () => {
    editDrawer.open();
  };
  const handleSendClick = () => {
    sendDrawer.open(null, null, { allowFormatSelection: true });
  };
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
      }}
    >
      <Button variant="outlined" color="secondary" onClick={handleSendClick}>
        <SvgIcon
          sx={{
            fontSize: 18,
            marginRight: 1,
            color: 'primary.main',
          }}
        >
          <SendIcon />
        </SvgIcon>
        {I18n.t('SentDocuments.Send document')}
      </Button>
      <Button variant="contained" color="primary" onClick={handleCreateClick}>
        <DescriptionOutlinedIcon sx={{ fontSize: 18, mr: 1 }} />
        {I18n.t('SentDocuments.New template')}
      </Button>
    </Box>
  );
};

export default SentDocumentsToolbar;
